import { Skeleton } from '../../../components/general/Skeleton.tsx';

function FieldSkeleton() {
    return (
        <div className="flex flex-col gap-1.5">
            <Skeleton className="h-2.5 w-20" />
            <Skeleton className="h-8 w-full" />
        </div>
    );
}

export function EditorSkeleton() {
    return (
        <div role="status" aria-busy="true" aria-label="Document wordt geladen" className="flex flex-col gap-5 px-4 pt-3">
            <div className="flex items-center gap-2">
                <Skeleton className="h-2.5 w-8" />
                <Skeleton className="h-8 w-24 rounded-full" />
                <Skeleton className="h-8 w-20 rounded-full" />
            </div>
            <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                <FieldSkeleton />
                <FieldSkeleton />
                <FieldSkeleton />
                <FieldSkeleton />
            </div>
            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <Skeleton className="h-2.5 w-16" />
                    <Skeleton className="h-7 w-40" />
                </div>
                <div className="overflow-hidden rounded-md border border-gray-200">
                    <Skeleton className="h-7 w-full rounded-none" />
                    {[0, 1, 2].map((row) => (
                        <div key={row} className="flex items-center gap-2 border-t border-gray-100 px-2 py-1.5">
                            <Skeleton className="h-7 w-44" />
                            <Skeleton className="h-7 flex-1" />
                            <Skeleton className="h-7 w-24" />
                            <Skeleton className="h-7 w-32" />
                            <Skeleton className="h-7 w-20" />
                        </div>
                    ))}
                </div>
            </div>
            <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                <FieldSkeleton />
                <FieldSkeleton />
                <FieldSkeleton />
                <FieldSkeleton />
            </div>
        </div>
    );
}

export function PreviewSkeleton() {
    return (
        <div aria-hidden="true" className="flex h-full w-full items-start justify-center bg-gray-100 p-6">
            <div className="flex w-full max-w-[520px] flex-col gap-4 rounded-md bg-white p-8 shadow-sm">
                <div className="flex items-start justify-between">
                    <Skeleton className="h-10 w-24" />
                    <div className="flex flex-col items-end gap-2">
                        <Skeleton className="h-3 w-32" />
                        <Skeleton className="h-3 w-24" />
                    </div>
                </div>
                <div className="flex flex-col gap-2 pt-4">
                    <Skeleton className="h-3 w-3/5" />
                    <Skeleton className="h-3 w-2/5" />
                </div>
                <div className="flex flex-col gap-2 pt-6">
                    {[0, 1, 2, 3, 4].map((row) => (
                        <Skeleton key={row} className="h-3 w-full" />
                    ))}
                </div>
                <div className="flex justify-end pt-4">
                    <Skeleton className="h-4 w-40" />
                </div>
            </div>
        </div>
    );
}
